<template>
  <div class="l-container DocumentsIndex">

    <button @click="postDocument">add</button>
    <button @click="resetSearch">Reset</button>

    <div class="index-box" @scroll="offset">

      <!-- <ul> -->
      <!--   <!&#45;&#45; <li> &#45;&#45;> -->
      <!--   <!&#45;&#45;   <template v&#38;#45;if="office_id"> &#45;&#45;> -->
      <!--   <!&#45;&#45;     <div class="search sticky&#38;#45;1"> &#45;&#45;> -->
      <!--   <!&#45;&#45;       <!&#38;#45;&#38;#45; <multiselect @select="searchTable()" v&#38;#38;#45;model="watch.office_id" :options="offices" label="name" :show&#38;#38;#45;labels="false" placeholder=""></multiselect> &#38;#45;&#38;#45;> &#45;&#45;> -->
      <!--   <!&#45;&#45;       <select v&#38;#45;model="search.office_id" class="select" @change="searchTable"> &#45;&#45;> -->
      <!--   <!&#45;&#45;         <option v&#38;#45;for="(list, index) in offices" :key="index" :value="list.id">{{ list.name }}</option> &#45;&#45;> -->
      <!--   <!&#45;&#45;       </select> &#45;&#45;> -->
      <!--   <!&#45;&#45;     </div> &#45;&#45;> -->
      <!--   <!&#45;&#45;   </template> &#45;&#45;> -->
      <!--   <!&#45;&#45; </li> &#45;&#45;> -->
      <!--   <li> -->
      <!--     <template v&#45;if="category"> -->
      <!--       <div class="search sticky&#45;1"> -->
      <!--         <!&#45;&#45; <multiselect @select="searchTable()" v&#38;#45;model="watch.category" :options="categorySelect" label="name" :show&#38;#45;labels="false" placeholder=""></multiselect> &#45;&#45;> -->
      <!--         <select v&#45;model="search.category" class="select" @change="searchTable"> -->
      <!--           <option v&#45;for="(list, index) in categorySelect" :key="index" :value="list.value">{{ list.name }}</option> -->
      <!--         </select> -->
      <!--       </div> -->
      <!--     </template> -->
      <!--   </li> -->
      <!--   <li> -->
      <!--     <template v&#45;if="title"> -->
      <!--       <div class="search sticky&#45;1"> -->
      <!--         <input v&#45;model="search.title" type="text" @keyup="searchTable()"> -->
      <!--       </div> -->
      <!--     </template> -->
      <!--   </li> -->
      <!-- </ul> -->

      <table-c>

        <tr-c slot="tr-th">
          <!-- <template v&#45;if="office_id"> -->
          <!--   <td&#45;c class="select sticky&#45;1"> -->
          <!--     <multiselect @select="searchTable()" v&#45;model="watch.office_id" :options="offices" label="name" :show&#45;labels="false" placeholder=""></multiselect> -->
          <!--   </td&#45;c> -->
          <!-- </template> -->
          <template v-if="category">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.category" :options="categorySelect" label="name" :show-labels="false" placeholder=""></multiselect>
            </td-c>
          </template>
          <template v-if="title"><td-c class="sticky-1"><input v-model="search.title" type="text" @keyup="searchTable()"></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <!-- <template v&#45;if="office_id"><th&#45;c class="sticky&#45;3" @click.native='sort("office_id")' v&#45;ripple>office</th&#45;c></template> -->
          <template v-if="category"><th-c class="sticky-3" @click.native='sort("category")'>category</th-c></template>
          <template v-if="title"><th-c class="sticky-3" @click.native='sort("title")'>title</th-c></template>
        </tr-c>

        <tr-c @click.native='linkDocument(list)' slot="tr-td" v-for="(list, index) in mapDocuments" :key="index.id" class="tr_hover">
          <!-- <template v&#45;if="office_id"><td&#45;c>{{ list.mapOffice }}</td&#45;c></template> -->
          <template v-if="category"><td-c>{{ list.mapCategory }}</td-c></template>
          <template v-if="title"><td-c>{{ list.title }}</td-c></template>
        </tr-c>
      </table-c>
    </div>
  </div>
</template>

<script>
import { getAPIURL } from '@/store/getters.js'
import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/documents/search?limit=' + config.LIMIT

var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url,
  searchUrl: url,
  pageName: 'document',
  pageNames: 'documents'
}

let _ = window._
export default {
  data () {
    return {
      column: false,
      sortState: '降順',
      sortColumn: 'id',

      id: true,
      office_id: true,
      user_id: true,
      category: true,
      title: true,
      note: true,
      created_at: true,
      updated_at: true,

      search: {
        id: '',
        office_id: '',
        user_id: '',
        category: '',
        title: '',
        note: '',
        created_at: '',
        updated_at: '',

        not_id: '',
        not_office_id: '',
        not_user_id: '',
        not_category: '',
        not_title: '',
        not_note: '',
        not_created_at: '',
        not_updated_at: ''
      },

      watch: {
        office_id: '',
        user_id: '',
        category: '',

        not_office_id: '',
        not_user_id: '',
        not_category: ''
      }
    }
  },
  computed: {
    obj () {
      return obj
    },

    categorySelect () {
      return this.$store.getters['documents/category']
    },

    max () {
      return this.$store.getters.max
    },

    documents () {
      return this.$store.getters.documents
    },

    users () {
      return this.$store.getters.users
    },

    user () {
      return this.$store.getters.user
    },

    filteredUsers () {
      let self = this
      if (self.user.office_id === 1) {
        return self.users.filter((user) => {
          return user.office_id === 1 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 2) {
        return self.users.filter((user) => {
          return user.office_id === 2 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 3) {
        return self.users.filter((user) => {
          return user.office_id === 3 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 4) {
        return self.users.filter((user) => {
          return user.office_id === 4 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 5) {
        return self.users.filter((user) => {
          return user.office_id === 5 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 6) {
        return self.users.filter((user) => {
          return user.office_id === 6 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 7) {
        return self.users.filter((user) => {
          return user.office_id === 7 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 8) {
        return self.users.filter((user) => {
          return user.office_id === 8 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 9) {
        return self.users.filter((user) => {
          return user.office_id === 9 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 10) {
        return self.users.filter((user) => {
          return user.office_id === 10 && user.hide_flag !== 1
        })
      } else {
        return self.users.filter((user) => {
          return user.hide_flag !== 1
        })
      }
    },

    offices () {
      return this.$store.getters.offices
    },

    orderedDocuments () {
      if (this.sortState === '' || this.sortState === '降順') {
        return _.orderBy(this.documents, this.sortColumn).reverse()
      } else if (this.sortState === '昇順') {
        return _.orderBy(this.documents, this.sortColumn)
      }
    },

    mapDocuments () {
      let self = this
      return self.orderedDocuments.map(document => {
        // document.mapOffice = self.calcArry(document.office_id, 'offices')
        document.mapCategory = self.calcSelect(document.category, 'categorySelect')
        document.mapCreated_at = self.calcDateTime(document.created_at)
        document.mapUpdated_at = self.calcDateTime(document.updated_at)
        return document
      })
    }
  },
  watch: {
    'watch.office_id': function (now, old) {
      if (now) {
        this.search.office_id = now.id
      } else {
        this.search.office_id = ''
      }
    },

    'watch.not_office_id': function (now, old) {
      if (now) {
        this.search.not_office_id = now.id
      } else {
        this.search.not_office_id = ''
      }
    },

    'watch.user_id': function (now, old) {
      if (now) {
        this.search.user_id = now.id
      } else {
        this.search.user_id = ''
      }
    },

    'watch.not_user_id': function (now, old) {
      if (now) {
        this.search.not_user_id = now.id
      } else {
        this.search.not_user_id = ''
      }
    },

    'watch.category': function (now, old) {
      if (now) {
        this.search.category = now.value
      } else {
        this.search.category = ''
      }
    },

    'watch.not_category': function (now, old) {
      if (now) {
        this.search.not_category = now.value
      } else {
        this.search.not_category = ''
      }
    }
  },
  methods: {
    calcDateTime (val) {
      const datetime = new Date(val)
      const year = datetime.getFullYear()
      let month = datetime.getMonth() + 1
      month = month.toString()
      month = month.padStart(2, '0')
      let date = datetime.getDate()
      date = date.toString()
      date = date.padStart(2, '0')
      let hours = datetime.getHours()
      hours = hours.toString()
      hours = hours.padStart(2, '0')
      let minutes = datetime.getMinutes()
      minutes = minutes.toString()
      minutes = minutes.padStart(2, '0')
      return year + '/' + month + '/' + date + ' ' + hours + ':' + minutes
    },

    postDocument () {
      this.$store.dispatch('postDocument', {
        this: this
      })
    },

    calcArry (val, text) {
      if (val) {
        return this[text].filter(item => {
          return item.id === val
        })[0].name
      } else {
        return 'admin'
      }
    },

    calcSelect (val, text) {
      if (val) {
        return this[text].filter(item => {
          return item.value === val
        })[0].name
      } else {
        return '-'
      }
    },

    select (selectedOption, id) {
      // console.log(selectedOption)
    },

    linkDocument (list) {
      const arr = [
        'id',
        'user_id',
        'office_id',
        'category',
        'title',
        'note',
        'created_at',
        'updated_at'
      ]
      arr.forEach((item) => {
        this.$store.state.item.document[item] = list[item]
      })
      this.$router.push({name: 'documentindex', params: { id: list.id }})
    },

    switchV (col) {
      this[col] = !this[col]
    },

    reset () {
      this.id = false
      this.office_id = false
      this.user_id = false
      this.category = false
      this.title = false
      this.note = false
      this.created_at = false
      this.updated_at = false
    },

    all () {
      this.id = true
      this.office_id = true
      this.user_id = true
      this.category = true
      this.title = true
      this.note = true
      this.created_at = true
      this.updated_at = true
    },

    def () {
      this.id = false
      this.office_id = true
      this.user_id = true
      this.category = true
      this.title = true
      this.note = true
      this.created_at = true
      this.updated_at = true
    },

    sort (header) {
      if (this.sortState === '' || this.sortState === '降順') {
        this.sortState = '昇順'
        this.sortColumn = header
      } else if (this.sortState === '昇順') {
        this.sortState = '降順'
        this.sortColumn = header
      }
    },

    offset (e) {
      this.$store.dispatch('SCROLL', {
        this: this,
        e: e,
        obj: obj
      })
    },

    searchTable (e) {
      this.$store.dispatch('SEARCH', {
        this: this,
        e: e,
        obj: obj
      })
    },

    resetSearch () {
      this.search.id = ''
      this.watch.office_id = 0
      // this.search.office_id = 0
      this.watch.user_id = 0
      this.watch.category = 0
      // this.search.category = 0
      this.search.title = ''
      this.search.note = ''
      this.search.created_at = ''
      this.search.updated_at = ''

      this.search.not_id = ''
      this.watch.not_office_id = 0
      this.watch.not_user_id = 0
      this.watch.not_category = 0
      this.search.not_title = ''
      this.search.not_note = ''
      this.search.not_created_at = ''
      this.search.not_updated_at = ''

      this.searchTable()
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // alert('get')
      let getjson = localStorage.getItem('documentsSearch')
      let obj = JSON.parse(getjson)

      vm.search.id = obj['id']
      vm.watch.office_id = obj['office_id']
      vm.watch.user_id = obj['user_id']
      vm.watch.category = obj['category']
      vm.search.title = obj['title']
      vm.search.note = obj['note']
      vm.search.created_at = obj['created_at']
      vm.search.updated_at = obj['updated_at']

      vm.search.not_id = obj['not_id']
      vm.watch.not_office_id = obj['not_office_id']
      vm.watch.not_user_id = obj['not_user_id']
      vm.watch.not_category = obj['not_category']
      vm.search.not_title = obj['not_title']
      vm.search.not_note = obj['not_note']
      vm.search.not_created_at = obj['not_created_at']
      vm.search.not_updated_at = obj['not_updated_at']

      vm.id = obj['column_id']
      vm.office_id = obj['column_office_id']
      vm.user_id = obj['column_user_id']
      vm.category = obj['column_category']
      vm.title = obj['column_title']
      vm.note = obj['column_note']
      vm.created_at = obj['column_created_at']
      vm.updated_at = obj['column_updated_at']

      // console.log(obj)
      vm.searchTable()
    })
  },
  beforeRouteLeave (to, from, next) {
    // alert('save')
    let arr = []
    let obj = {

      id: this.search.id,
      office_id: this.watch.office_id,
      user_id: this.watch.user_id,
      category: this.watch.category,
      title: this.search.title,
      note: this.search.note,
      created_at: this.search.created_at,
      updated_at: this.search.updated_at,

      not_id: this.search.not_id,
      not_office_id: this.watch.not_office_id,
      not_user_id: this.watch.not_user_id,
      not_category: this.watch.not_category,
      not_title: this.search.not_title,
      not_note: this.search.not_note,
      not_created_at: this.search.not_created_at,
      not_updated_at: this.search.not_updated_at,

      column_id: this.id,
      column_office_id: this.office_id,
      column_user_id: this.user_id,
      column_category: this.category,
      column_title: this.title,
      column_note: this.note,
      column_created_at: this.created_at,
      column_updated_at: this.updated_at
    }
    arr.push(obj)
    let setjson = JSON.stringify(obj)
    localStorage.setItem('documentsSearch', setjson)
    next()
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
/* .sticky-1 { */
/*   position: sticky; */
/*   top: 0; */
/*   background: #fff; */
/*   &:before { */
/*     content: ''; */
/*     position: absolute; */
/*     display: block; */
/*     background: #ccc; */
/*     height: 1px; */
/*     width: 100%; */
/*     left: 0; */
/*     top: -1px; */
/*   } */
/* } */
/* .sticky-2 { */
/*   position: sticky; */
/*   top: 24px; */
/*   background: #fff; */
/*   &:before { */
/*     content: ''; */
/*     position: absolute; */
/*     display: block; */
/*     background: #ccc; */
/*     height: 1px; */
/*     width: 100%; */
/*     left: 0; */
/*     top: -1px; */
/*   } */
/* } */
/* .sticky-3 { */
/*   position: sticky; */
/*   top: 49px; */
/*   &:before { */
/*     content: ''; */
/*     position: absolute; */
/*     display: block; */
/*     background: #ccc; */
/*     height: 1px; */
/*     width: 100%; */
/*     left: 0; */
/*     top: -1px; */
/*   } */
/*   &:after { */
/*     content: ''; */
/*     position: absolute; */
/*     display: block; */
/*     background: #ccc; */
/*     height: 1px; */
/*     width: 100%; */
/*     left: 0; */
/*     bottom: -1px; */
/*   } */
/* } */
.m-label-custom {
  z-index: 1;
  cursor: pointer;
  margin-bottom: 1px;
}
.slideActive {
  background: #455A64;
  color: #fff;
}
.active {
  background: #455A64;
  border: solid 1px #455A64;
  color: #fff;
}
.resetSearch {
  padding: 7px 0;
}
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
.select {
  padding: 0 !important;
}
input {
  width: 100%;
  min-width: 100px;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}
.index-box {
  height: calc(100vh - 130px);
  overflow: scroll;
  margin-top: 10px;
  &:after {
    content: "\f02d";
    font-family: FontAwesome;
    position: absolute;
    font-size: 250px;
    top: 50%;
    left: 50%;
    margin-top: -125px;
    margin-left: -125px;
    /* color: #ddd; */
    color: #aaa;
    opacity: 0.1;
    z-index: -1;
  }
}
</style>

<style lang="scss">
.DocumentsIndex {
  .multiselect {
    min-height: 23px;
    min-width: 110px;
  }
  .multiselect__tag {
    margin: 1px;
    font-size: 10px;
  }
  .multiselect__tag-icon {
    line-height: 18px;
    &:after {
      font-size: 10px;
    }
  }
  .multiselect__tags {
    border: solid 1px #ccc;
    min-height: 23px;
    padding: 0px 23px 0 2px;
    border-radius: 0;
    border: none;
    margin: 3px 1px 1px 1px;
  }
  .multiselect__tags-wrap {
    /* background: red; */
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 23px;
  }
  .multiselect__select {
    height: 23px;
    width: 26px;
    top: 2px;
    padding: 0;
    &:before {
      top: 75%;
    }
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// DocumentsIndex.vue?763c1c1e